"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SIACMSContent = _interopRequireDefault(require("../SIACMSContent/SIACMSContent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-organisation-massmailing {\n  display: flex;\n  max-width: 765px;\n  flex-direction: column;\n  margin: auto;\n  padding-top: 24px;\n  padding-inline: 32px; }\n";
  const fileName = "SIAOrganisationMassmailing_SIAOrganisationMassmailing";
  const element = document.querySelector("style[data-sass-component='SIAOrganisationMassmailing_SIAOrganisationMassmailing']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIAOrganisationMassmailing = _ref => {
  let {
    item,
    lang,
    history
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-organisation-massmailing"
  }, /*#__PURE__*/_react.default.createElement(_SIACMSContent.default, {
    lang: lang,
    items: item.mail_body,
    history: history
  }));
};
SIAOrganisationMassmailing.propTypes = {
  item: _propTypes.default.object.isRequired
};
var _default = exports.default = SIAOrganisationMassmailing;